const addLabelToStyles = (label, styles) => {
    if (typeof styles === 'function') {
        return (...args) => {
            return [{ label }, styles(...args)];
        };
    }
    return [{ label }, styles];
};
export const labelStyles = (block, allStyles) => {
    return (Object.entries(allStyles)
        .map(([name, styles]) => {
        const label = name.startsWith('root') ? block : `${block}__${name}`;
        return [name, addLabelToStyles(label, styles)];
    })
        .reduce((mapped, [name, styles]) => {
        mapped[name] = styles;
        return mapped;
    }, {}));
};
//# sourceMappingURL=labelStyles.js.map
// @zapier/style-encapsulation@1.3.1 (2376bbd83)
